import React from 'react';
import logo from '../../assets/logo_dourado.png';
import './styles.scss';

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="itauna-footer">
            <div className="footer-content">
                <div className="footer-section">
                    <div className="footer-brand">
                        <a 
                            href="https://itaunaconsultoria.com.br/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-logo-link"
                        >
                            <img src={logo} alt="Itaúna Logo" className="footer-logo-img" />
                        </a>
                    </div>
                    <p className="text-muted">A Itauna Advisors é credenciada à CVM.</p>
                </div>

                <div className="footer-section">
                    <h6>Segurança</h6>
                    <ul className="footer-links">
                        <li>🔒 Pagamentos PCI-DSS</li>
                        <li>🛡️ Dados criptografados</li>
                        <li>✅ SSL/TLS</li>
                    </ul>
                </div>

                <div className="footer-section">
                    <h6>Contato</h6>
                    <ul className="footer-links">
                        <li>📧 leonardo.leite@itaunaconsultoria.com.br</li>
                        <li>📞 (21) 3958-1228</li>
                        <li>📍 Av. Atlântica, 1.130, 14° B, Copacabana, RJ</li>
                    </ul>
                </div>
            </div>

            <div className="footer-bottom">
                <p>&copy; {currentYear} Itaúna. Todos os direitos reservados.</p>
                <p className="powered-by">Powered by Pagar.me</p>
            </div>
        </footer>
    );
};

export default Footer;
